module.exports = __webpack_public_path__ + "static/media/Pulse-1s-200px.3ab334b0.svg";